import { Pressable, View } from 'react-native'
import { Text } from '~/components/ui/text'

type RadioOptionProps<T extends string> = {
  value: T
  selected: boolean
  onSelect: (value: T) => void
  label: string
}

export function RadioOption<T extends string>({
  value,
  selected,
  onSelect,
  label,
}: RadioOptionProps<T>) {
  return (
    <Pressable onPress={() => onSelect(value)} className="flex-row items-center gap-2">
      <View
        className={`size-5 items-center justify-center rounded-full border ${selected ? 'border-primary bg-primary' : 'border-neutral-300 bg-white'}`}>
        {selected && <View className="size-2 rounded-full bg-white" />}
      </View>
      <Text>{label}</Text>
    </Pressable>
  )
}
